import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base =
  "group inline-flex items-center gap-2 rounded-full font-mono-label text-[11px] font-semibold transition-colors duration-200 disabled:opacity-60";

const sizes = {
  md: "px-5 py-2.5",
  lg: "px-6 py-3.5 text-[12px]",
};

const variants = {
  dark: "bg-oath-ink text-white hover:bg-black",
  accent: "bg-oath-accent text-white hover:bg-oath-accent-hover",
  white: "bg-white text-oath-ink border border-gray-300 hover:border-oath-ink",
};

export const PillButton = ({
  children,
  variant = "dark",
  size = "md",
  arrow = true,
  as = "button",
  to,
  href,
  className = "",
  ...props
}) => {
  const content = (
    <>
      {children}
      {arrow && (
        <span
          className={`grid h-5 w-5 place-items-center rounded-full ${
            variant === "white" ? "bg-oath-ink text-white" : "bg-white/20"
          } transition-transform duration-200 group-hover:translate-x-0.5`}
        >
          <ArrowRight className="h-3 w-3" strokeWidth={2.5} />
        </span>
      )}
    </>
  );
  const cls = `${base} ${sizes[size]} ${variants[variant]} ${className}`;

  if (to) return <Link to={to} className={cls} {...props}>{content}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{content}</a>;
  const Tag = as;
  return <Tag className={cls} {...props}>{content}</Tag>;
};

export default PillButton;
